import { render, staticRenderFns } from "./report-new.vue?vue&type=template&id=fdf0d3d2"
import script from "./report-new.vue?vue&type=script&lang=js"
export * from "./report-new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports